import style from "./Button.module.css"
import {useEffect, useState} from "react";
import MediaQueryUtils from "../../utils/MediaQueryUtils";

// const btnBase = "btn btnBlu";
// const btnOut = "btn btnBluOutline";
// const btnDis = "btn btn-primary disabled btnDisabled";
// const btnDisOut = "btn disabled btnDisabledOutline";
//
// const btnViola = "btn btnViola";
// const btnViolaOut = "btn btnOutlineViola";
//
// const btnWarning = "btn btnWarning";
// const btnWarningOut = "btn btnWarningOutline";


function Button(props) {

    const [className, setClassName] = useState("")

    let isPageWide = MediaQueryUtils('(min-width: 800px)')

    useEffect(() => {
        if (props.typeButton === "Blue") {
            setClassName(style.btnBlu)
        } else if (props.typeButton === "White") {
            setClassName(style.btnWhite)
        }
    })

    return (
        <>
        <button
            data-toggle={props.dataToggle}
            data-target={props.dataTarget ? "#".concat(props.dataTarget) : undefined}
            data-dismiss={props.dataDismiss}
            data-keyboard={props.dataKeyboard}
            data-backdrop={props.dataBackdrop}
            type={"button"}
            id={props.id}
            onClick={props.onClick}
            style={props.style}
            disabled={props.disabled}
            className={className.concat(" ").concat(props.className)}
        ><div className={"row"} style={{justifyContent:"center"}}>
            {props.icon ? props.icon : ''}
            <span style={{paddingTop:props.icon ?"0.1rem":""}}>{props.text}</span>
        </div>
        </button>


            {/* Il blocco modale era reso SEMPRE, anche per i pulsanti che non aprono
                alcuna modale: da qui 20-30 role="dialog" per pagina (rumore semantico,
                WCAG 4.1.2). Ora e' reso solo quando dataTarget e' valorizzato, cioe'
                esattamente quando la modale esiste davvero.
                aria-labelledby puntava all'id fisso "exampleModalLabel", duplicato su
                ogni modale e non corrispondente ad alcun elemento: ora punta all'id
                derivato da dataTarget, applicato all'elemento che contiene l'intestazione. */}
            {props.dataTarget ?
            <div className="modal fade" id={props.dataTarget} tabIndex="-1" role="dialog"
                 aria-labelledby={`${props.dataTarget}-titolo`} aria-hidden="true">
                <div className={"modal-dialog ".concat(style.alignModal)} role="document" >
                    <div className="modal-content" style={{width: isPageWide ? "700px" : "600px"}}>
                        <div className="modal-header" style={{alignSelf: "center"}}>
                            <p id={`${props.dataTarget}-titolo`} className={style.fontHeaderModal}>{props.header}</p>
                        </div>
                        <div className="modal-body">
                            {props.body}
                        </div>
                    </div>
                </div>
            </div> : null}

        </>
    );


}

export default Button
